import { Controller, type Control, type FieldValues, type Path, type RegisterOptions } from 'react-hook-form'
import { TextBox, type TextBoxProps } from '../common/TextBox'

type TextBoxFieldProps<T extends FieldValues, TName extends Path<T>> = Omit<
  TextBoxProps,
  'name' | 'value' | 'onChange' | 'onBlur' | 'error'
> & {
  control: Control<T>
  name: TName
  rules?: RegisterOptions<T, TName>
  /** Override the error message (otherwise derived from the field's RHF error). */
  error?: string
}

export function TextBoxField<T extends FieldValues, TName extends Path<T>>({
  control,
  name,
  rules,
  error: errorOverride,
  ...textBoxProps
}: TextBoxFieldProps<T, TName>) {
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field, fieldState }) => (
        <TextBox
          {...textBoxProps}
          name={field.name}
          value={typeof field.value === 'string' ? field.value : (field.value ?? '').toString()}
          onChange={field.onChange}
          onBlur={field.onBlur}
          error={errorOverride ?? fieldState.error?.message}
        />
      )}
    />
  )
}
